import Vue from 'vue';
import Big from 'big.js';
Vue.prototype.$big = Big;
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/table-row-styles.css';
import App from './App.vue'
import VueRouter from 'vue-router'
import routers from './router/index'
import axios from 'axios'
import VueAxios from 'vue-axios'
 axios.defaults.baseURL='/api'
import moment from "moment";
//axios.defaults.baseURL=process.env.VUE_APP_URL
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';

import store from './store'
Vue.use(Avue);

axios.interceptors.request.use(
    config => {
      const token = sessionStorage.getItem("token");
      if(token !== undefined && token != null){
          token && (config.headers.token = token);
      }
      return config;
    },
    error => {
      return Promise.error(error);
    })

axios.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (response.data.code === 203) {
            sessionStorage.removeItem("userName")
            router.push({
                path: '/',
            })
            return Promise.reject(response);
        } else {
            return Promise.resolve(response);
        }
    },
    error => {
      // 处理 500 错误
      if (error.response && error.response.status === 500) {
        ElementUI.Message({
          message: error.response.data.message,
          type: 'error',
          duration: 6000,    // 显示 6 秒（单位是毫秒）
          showClose: true    // 显示右上角关闭按钮
        });
        // 你可以选择不传递错误，避免进一步泄露错误详情
        return Promise.reject(error.response);
      }
    }
)



Vue.prototype.$CreateTimeFormat =function (time) {
  if (time !== null && time !== undefined) {
    return moment(time).format("YYYY-MM-DD HH:mm:ss");
  }
}

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(VueAxios,axios);
const router = new VueRouter({
  mode: 'history',
  routes: routers
})
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')


